export class SimulationContext
{
  /**
   * Коли true — гра працює в headless-режимі симуляції:
   * без VFX, звуку, вібрації, аналітики, оверлеїв та реклами.
   */
  public static enabled = false;
}

export interface SimulationRunResult
{
  won: boolean;
  shots_used: number;
  sim_seconds: number;
}